<template>
    <div class="error-page p-5">
        <img src="@/assets/site_img/error.png">
        <p class="mt-3">There has been an <b>issue</b>.<br/>Please consult your <b>system administrators</b>.</p>
        <router-link to="/applicantList" v-on:click="goToHomePage" class="text-decoration-none"><i class="bi bi-arrow-left"></i> Go To Home Page</router-link>
    </div>
</template>
<script>
export default {
    methods: {
        goToHomePage(){
            localStorage.removeItem('errorFlag');
        }
    }
};
</script>